import React from 'react';
import Header from '../components/header'; 
import Footer from '../components/footer'; 

const PrivacyPolicy = () => {
  return (
    <div>
      <Header />
      
<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/9.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Privacy Policy</div>
					</div>
				</div>
			</div>
		</div>
	</div>

<div>
<div className="container">

<div className="card policy-card p-4 p-md-5">

<p>
At <strong>Hotel Pahadi Convention</strong>, we value the privacy and security of our guests and website visitors.
This Privacy Policy explains how we collect, use, and protect your personal information when you use our website,
make a reservation, or use our services.
</p>

<hr/>

<h6>1. Information We Collect</h6>

<p>We may collect the following types of personal information from our guests and website users:</p>

<ul>
<li><strong>Personal Identification Information:</strong> Name, phone number, email address, and postal address.</li>
<li><strong>Booking Information:</strong> Reservation details, check-in and check-out dates, room preferences, and payment information.</li>
<li><strong>Identity Verification:</strong> Government-issued identification details required for hotel check-in as per local regulations.</li>
<li><strong>Website Usage Information:</strong> IP address, browser type, device information, and pages visited on our website.</li>
</ul>

<hr/>

<h6>2. How We Use Your Information</h6>

<p>The information collected may be used for the following purposes:</p>

<ul>
<li>To process and confirm hotel reservations.</li>
<li>To provide customer service and respond to inquiries.</li>
<li>To improve our hotel services and website experience.</li>
<li>To comply with legal obligations and government regulations.</li>
<li>To send booking confirmations, updates, or service-related communication.</li>
</ul>

<hr/>

<h6>3. Sharing of Information</h6>

<p>
Hotel Pahadi Convention does not sell, rent, or trade your personal information.
However, we may share information in the following situations:
</p>

<ul>
<li>With trusted service providers involved in booking, payment processing, or website management.</li>
<li>With government authorities or law enforcement when required by law.</li>
<li>When necessary to protect the rights, property, or safety of the hotel, guests, or staff.</li>
</ul>

<hr/>

<h6>4. Data Security</h6>

<p>
We implement appropriate security measures to protect your personal information
from unauthorized access, misuse, or disclosure. While we strive to safeguard
your data, no online system can guarantee complete security.
</p>

<hr/>

<h6>5. Cookies and Website Tracking</h6>

<p>
Our website may use cookies and analytics tools to enhance user experience and
understand how visitors interact with our website.
</p>

<p>Cookies help us:</p>

<ul>
<li>Improve website functionality</li>
<li>Analyze traffic and user behavior</li>
<li>Remember user preferences</li>
</ul>

<p>
You can choose to disable cookies thr/ough your browser settings.
</p>

<hr/>

<h6>6. Retention of Information</h6>

<p>
We retain personal information only for as long as necessary to fulfill the purposes
outlined in this policy, including legal and regulatory requirements.
</p>

<hr/>

<h6>7. Third-Party Links</h6>

<p>
Our website may contain links to third-party websites or booking platforms.
Hotel Pahadi Convention is not responsible for the privacy practices or
content of those external sites.
</p>

<hr/>

<h6>8. Your Rights</h6>

<p>Guests and users have the right to:</p>

<ul>
<li>Request access to their personal information.</li>
<li>Request correction or update of inaccurate information.</li>
<li>Request deletion of personal data where applicable by law.</li>
</ul>

<hr/>

<h6>9. Updates to This Privacy Policy</h6>

<p>
Hotel Pahadi Convention reserves the right to update or modify this Privacy Policy
at any time. Changes will be posted on this page with the updated revision date.
</p>

<hr/>

<h6>10. Contact Us</h6>

<p>
If you have any questions regarding this Privacy Policy or how your information is handled,
please contact us:
</p>

<p> <strong>Hotel Pahadi Convention</strong><br></br>
	Hotel Pahadi, Vedvyas, Rourkela, Odisha, India<br></br>
	Email: info@hotelpahadi.com<br></br>
	Phone: +91 9238394006, +91 9692908506 </p>

</div>

</div>
</div>

<br />
        <Footer />
    </div>
  )
}

export default PrivacyPolicy;